export const careerRoutes = {
  root: '/career',
  position: '/career/:id',
  apply: '/career/apply/:id/:name',
};
